@let hasShiftUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Shift);

<button
  nz-button
  nzType="default"
  class="w-100 fw-normal"
  (click)="updateShifts()"
  [disabled]="
    !hasShiftUpdatePermission ||
    !(selectedShifts | canAllShiftBeModified) ||
    areShiftsAllUnassigned ||
    isOperationOnGoing
  "
  nz-tooltip
  [nzTooltipTitle]="
    !hasShiftUpdatePermission ? ('general.forbidden_action' | translate) : ''
  "
>
  {{ 'shift.page.action.unassign_shifts' | translate }}
</button>
